var map = {
	"./template-1/dialogs/ticket-dialog": "app/styles/client/templates/template-1/dialogs/ticket-dialog",
	"./template-10/dialogs/ticket-dialog": "app/styles/client/templates/template-10/dialogs/ticket-dialog",
	"./template-11/dialogs/ticket-dialog": "app/styles/client/templates/template-11/dialogs/ticket-dialog",
	"./template-2/dialogs/ticket-dialog": "app/styles/client/templates/template-2/dialogs/ticket-dialog",
	"./template-3/dialogs/ticket-dialog": "app/styles/client/templates/template-3/dialogs/ticket-dialog",
	"./template-4/dialogs/ticket-dialog": "app/styles/client/templates/template-4/dialogs/ticket-dialog",
	"./template-5/dialogs/ticket-dialog": "app/styles/client/templates/template-5/dialogs/ticket-dialog",
	"./template-6/dialogs/ticket-dialog": "app/styles/client/templates/template-6/dialogs/ticket-dialog",
	"./template-7/dialogs/ticket-dialog": "app/styles/client/templates/template-7/dialogs/ticket-dialog",
	"./template-8/dialogs/ticket-dialog": "app/styles/client/templates/template-8/dialogs/ticket-dialog",
	"./template-9/dialogs/ticket-dialog": "app/styles/client/templates/template-9/dialogs/ticket-dialog"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3139;